const type = 'SET_PAYMENT_AMOUNT_INPUT';

const setPaymentAmountInput = (data) => ({
  data,
  type,
});

export { type };
export default setPaymentAmountInput;
